/**
 * 
 * @param {string} dateString 
 * @returns 
 */
export function formatDateToText(dateString) {
    // 1. Validate format and date existence
    const date = new Date(dateString);

    // Check if the date is invalid (e.g., "2026-13-45")
    if (isNaN(date.getTime())) {
        return null;
    }

    // 2. Extract components
    // Note: We use UTC methods or split the string to avoid timezone shifts
    const [year, month, day] = dateString.split('-').map(Number);
    const tempDate = new Date(year, month - 1, day);

    const dayNum = tempDate.getDate();
    const monthName = tempDate.toLocaleString('en-US', { month: 'long' });
    const yearNum = tempDate.getFullYear();

    // 3. Determine Ordinal Suffix (st, nd, rd, th)
    const getSuffix = (n) => {
        if (n > 3 && n < 21) return 'th';
        switch (n % 10) {
            case 1: return "st";
            case 2: return "nd";
            case 3: return "rd";
            default: return "th";
        }
    };

    return `${dayNum}${getSuffix(dayNum)} ${monthName} ${yearNum}`;
}